// NEW FILE: frontend/src/services/companyService.js

import api from '../config/api';

export const companyService = {
  // Register new company + admin user
  registerCompany: async (companyData) => {
    const response = await api.post('/api/users/register-company', {
      email: companyData.email,
      password: companyData.password,
      fullName: companyData.fullName,
      companyName: companyData.companyName,
      domain: companyData.domain
    });
    
    // Store auth data
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      localStorage.setItem('company', JSON.stringify(response.data.company));
    }
    
    return response.data;
  },

  // Get company profile
  getCompanyProfile: async () => {
    const response = await api.get('/api/companies/profile');
    return response.data;
  },

  // Update company profile
  updateCompanyProfile: async (companyData) => {
    const response = await api.put('/api/companies/profile', companyData);
    return response.data;
  }
};